import React from "react";
import PropTypes from "prop-types";
import { sortSizes } from "../../sizeOrder";
import styles from "./index.module.css";

/**
 * Read-only display of a product's variations.
 *
 * Rev 1: variations are owned by NetSuite. The admin app does NOT create or edit
 * them — it only surfaces what the product record carries (the catalog-card
 * summary: color + sizes) so an admin can see the variants at a glance. There is
 * intentionally no editing, no save, and no add/remove here.
 */
export default function NetSuiteVariationsCard({ variations }) {
  const list = Array.isArray(variations) ? variations : [];

  if (list.length === 0) {
    return (
      <p className={styles.empty}>
        No Product Variations Available (Add Variations to the Product in
        Netsuite)
      </p>
    );
  }

  return (
    <div className={styles.wrap}>
      <p className={styles.caption}>
        Variations are managed in NetSuite and shown here read-only.
      </p>
      <ul className={styles.list}>
        {list.map((variation, index) => {
          const sizes = sortSizes(
            Array.isArray(variation.sizes) ? variation.sizes : []
          );
          return (
            <li key={variation.id || index} className={styles.row}>
              <span className={styles.color}>{variation.color || "—"}</span>
              <div className={styles.sizes}>
                {sizes.length > 0 ? (
                  sizes.map((size, sizeIndex) => (
                    <span key={`${size}-${sizeIndex}`} className={styles.chip}>
                      {size}
                    </span>
                  ))
                ) : (
                  <span className={styles.noSizes}>No sizes</span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

NetSuiteVariationsCard.propTypes = {
  variations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      color: PropTypes.string,
      sizes: PropTypes.arrayOf(PropTypes.string),
    })
  ),
};

NetSuiteVariationsCard.defaultProps = {
  variations: [],
};
